import React from 'react'
import SearchLine from 'shared/components/SearchLine/SearchLine'
import { StudentSearchDropdown } from 'shared/components/StudentSearchDropdown/StudentSearchDropdown'
import s from './HeaderSearchBlock.module.scss'

export default function HeaderSearchBlock({
	containerRef,
	query,
	onSearchChange,
	onFocus,
	isOpen,
	isLoading,
	results,
	onSelectStudent,
	showClear = false,
	onClear,
	className = '',
}) {
	return (
		<div className={`${s.search} ${className}`} ref={containerRef}>
			<SearchLine
				onSearchChange={onSearchChange}
				placeholder="Search student"
				value={query}
				onFocus={onFocus}
				showClear={showClear}
				onClear={onClear}
				className={showClear ? s.searchLineExpanded : ''}
			/>
			<StudentSearchDropdown
				isOpen={isOpen}
				isLoading={isLoading}
				results={results}
				onSelectStudent={onSelectStudent}
			/>
		</div>
	)
}
